import React, { useEffect } from 'react';

function LegalPage({ page }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <main className="page-shell legal-shell">
      <article className="legal-card">
        <span className="eyebrow">Legal</span>
        <h1>{page.title}</h1>

        <div className="legal-sections">
          {page.sections.map((section) => (
            <section className="legal-section" key={section.heading}>
              <h2>{section.heading}</h2>
              <p>{section.text}</p>
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}

export default LegalPage;